// extracted by mini-css-extract-plugin
export default {"save":"TeamSettings_save__jCV+p"};